const digits = (s) => (s || "").replace(/\D/g, "");

export function matchCase(c, q) {
  const t = q.trim().toLowerCase();
  if (!t) return true;
  const p = c.patient || {};
  const text = [p.name, p.file_no, c.case_number, c.procedure_name].join(" ").toLowerCase();
  if (text.includes(t)) return true;
  const d = digits(t);
  return d.length >= 3 && (digits(p.phone).includes(d) || digits(c.case_number).includes(d));
}

export const caseKind = (c) => {
  if (c.status !== "pending") return "completed";
  return c.awaiting_clearance && !c.decision?.followups?.length ? "specialist" : "labs";
};

export const SEARCH_PLACEHOLDER = "Search name, phone, file no. or case no. (DC-…)";
